import { useStaticSiteConfig } from "@commerce-frontend/ui/providers/StaticSiteConfigProvider";
import { getStaticUrl, type pageTranslations } from "@commerce-shared/url";

/**
 * Returns a translated static url for a given static page name.
 *
 * @example
 * Given the current language is `fr` and the default locale is `nl-NL`
 * ```ts
 * useStaticUrl("search"); // "/fr/recherche"
 * ```
 */
export const useStaticUrl = (
	staticPageName: keyof typeof pageTranslations | "home",
	params?: Record<string, string>,
) => {
	const config = useStaticSiteConfig();

	return getStaticUrl(staticPageName, config.language, config.country, params);
};
